export const LINKS = {
  IOS_APP_STORE:
    "https://apps.apple.com/app/apple-store/id6523432233?pt=123978854&ct=Samphire_Landing_CTA&mt=8",
  ANDROID_PLAY_STORE:
    "https://play.google.com/store/apps/details?id=com.samphire.app&hl=en_US&pli=1",
  NETTLE_PAGE: "https://www.samphireneuro.com/nettle",
};
